var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { call } from '../../utils';
import namehash from 'eth-ens-namehash';
export var author = 'makoto';
export var version = '0.1.0';
var abi = [
    {
        inputs: [
            {
                internalType: 'address[]',
                name: 'addresses',
                type: 'address[]'
            }
        ],
        name: 'getNames',
        outputs: [
            {
                internalType: 'string[]',
                name: 'r',
                type: 'string[]'
            }
        ],
        stateMutability: 'view',
        type: 'function'
    }
];
var CONTRACTS = {
    '1': '0x3671aE578E63FdF66ad4F3E12CC0c0d71Ac7510C',
    '3': '0x5bBFe410e18DCcaebbf5fD7A00844d4255615258',
    '4': '0x196eC7109e127A353B709a20da25052617295F6f',
    '5': '0x333Fc8f550043f239a2CF79aEd5e9cF4A20Eb41e'
};
export function strategy(space, network, provider, addresses, options, snapshot) {
    return __awaiter(this, void 0, void 0, function () {
        var blockTag, contractAdress, response, r;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    blockTag = typeof snapshot === 'number' ? snapshot : 'latest';
                    contractAdress = CONTRACTS[network];
                    return [4 /*yield*/, call(provider, abi, [contractAdress, 'getNames', [addresses]], { blockTag: blockTag })];
                case 1:
                    response = _a.sent();
                    r = Object.fromEntries(response.map(function (value, i) {
                        var isEligible = value !== '' &&
                            namehash.normalize(value) === value &&
                            value.split('.').length === 2; // no subdomain
                        var number = isEligible ? 1 : 0;
                        return [addresses[i], number];
                    }));
                    return [2 /*return*/, r];
            }
        });
    });
}
